import {AdminRouteNames, AuthRouteNames, CustomerRouteNames, PlatformRouteNames} from "./route-names";

export const formatPath = (page: AuthRouteNames | AdminRouteNames | CustomerRouteNames | PlatformRouteNames) => {
  return `/${page}`
}
